<section class="login-page-section-top ">
    <div class="container">
      <div class="row">
        <div class="col-md-12 size-img back-img">
          <div class="effect-cover">
            <h3 class="txt-advert animated fadeInUp">CONTACT US</h3>
            <p class="txt-advert-sub animated">At TPL Sport, we greatly value your feedback, questions, and inquiries. Your input is essential in helping us <br> improve our services and better meet your needs. Feel free to reach out to us through any of the following  </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div *ngFor="let banner of bannerImageList " class="swiper-slide zoom-effect-container banner-image-div">
      <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
        <div class="headings image-card">
          <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
          <div class="slider-inner-div">
            <div class="container">
              <div class="main-heading-banner">
                <div class="sldier-bottom-section"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

<div *ngFor="let banner of webBannerImageList" class="swiper-slide zoom-effect-container banner-image-div web-view-banner">
	<div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
		<div class="headings image-card">
			<img [src]="banner.banner_image_src" class="product-image" alt="web banner" />
			<div class="slider-inner-div">
				<div class="container">
					<div class="main-heading-banner">
						<div class="sldier-bottom-section"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngFor="let banner of mobileBannerImageList"
	class="swiper-slide zoom-effect-container banner-image-div mobile-view-banner">
	<div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
		<div class="headings image-card">
			<img [src]="banner.banner_image_src" class="product-image" alt="mobile banner" />
			<div class="slider-inner-div">
				<div class="container">
					<div class="main-heading-banner">
						<div class="sldier-bottom-section"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

  </section>


<section class="contact-us-section">
	<div class="mobile_version-backbutton">
      <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""></span>Contact Us</a>
    </div>
<div class="container">
	<div class="row">
		<div class="col-md-12 mobile_border_top">
			<div class="d-flex">
			
				<div class="col-md-6 form-div ">
					<form [formGroup]="contactUsForm" *ngIf="this.contactUsForm"
					(ngSubmit)="onSubmit()">
					<div class="contact-form">
						<h4 class="mb-4">Get in touch with us.</h4>
						<p>At TPL Sport, we greatly value your feedback, questions and inquires. Feel free to reach out to us through any of the following</p>
						
						<div class="new_from_ui">
							<div class="row">
								<div class="col-lg-12">
									<div class="form-group">
										<label for="name">Name<span
												class="mandatory-fields">*</span></label>
										<input formControlName="name" type="text" pInputText
											class="form-control" placeholder="Enter Name"
											[ngClass]="{ 'is-invalid': ((submitted && f.name.errors) || (f.name.errors && (f.name.dirty || f.name.touched)))}">
										<div *ngIf="((submitted && f.name.errors) || (f.name.errors && (f.name.dirty || f.name.touched)))"
											class="invalid-feedback">
											<div *ngIf="f.name.errors.required">
												Name is required</div>
											<div *ngIf="!f.name.errors.required">Only
												Alphabets allowed</div>
										</div>
									</div>
								</div>
								<div class="col-lg-12">
									<div class="form-group">
										<label for="name">Email<span
												class="mandatory-fields">*</span></label>
										<input formControlName="email" type="email" pInputText
											placeholder="Enter E-Mail"
											[ngClass]="{ 'is-invalid': ((submitted && f.email.errors) || (f.email.errors && (f.email.dirty || f.email.touched)))}"
											class="form-control">
										<div *ngIf="((submitted && f.email.errors) || (f.email.errors && (f.email.dirty || f.email.touched)))"
											class="invalid-feedback">
											<div *ngIf="f.email.errors.required">
												Email is required</div>
											<div *ngIf="f.email.errors.email">
												Enter valid email address
											</div>
										</div>
									</div>
								</div>
								<div class="col-lg-12">
									<div class="form-group">
										<label for="name">Phone <span
											class="mandatory-fields">*</span></label>
										<input placeholder="Enter Phone Number"
											formControlName="mobileNumber" type="text"
											minlength="10" maxlength="12" pInputText
											class="form-control"
											[ngClass]="{ 'is-invalid': ((submitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))}">
										<div *ngIf="((submitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))"
											class="invalid-feedback">
											<div *ngIf="f.mobileNumber.errors.required">
												Phone Number is Required</div>
											<div *ngIf="!f.mobileNumber.errors.required">
												Please Check Phone Number
											</div>
										</div>
									</div>
								</div>
								<div class="col-lg-12">
									<div class="form-group">
										<label for="name">Message<span
												class="mandatory-fields">*</span></label>
										<textarea pInputTextarea formControlName="message"
											class="form-control" placeholder="Enter Message"
											[ngClass]="{ 'is-invalid': ((submitted && f.message.errors) || (f.message.errors && (f.message.dirty || f.message.touched)))}">
										</textarea>
										<div *ngIf="((submitted && f.message.errors) || (f.message.errors && (f.message.dirty || f.message.touched)))"
											class="invalid-feedback">
											<div *ngIf="f.message.errors.required">
												Message is required
											</div>
										</div>
									</div>
								</div>

								<div class="col-12 form-buttons mt-3">
									<button pButton pRipple label="Send Message" class="FS_button"></button>
								</div>
							</div>
						</div>
					</div>
				</form>
				</div>

				<div class="locate_border_top"></div>
				<div class="col-md-6 map-div ">
					<h4 class="mb-4">Locate us at</h4>
					<div class="map-box">
						<iframe
							src="https://maps.google.com/maps?width=600&height=400&hl=en&q=mumbai&t=&z=14&ie=UTF8&iwloc=B&output=embed"
							width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
					</div>
				</div>
				<div class="locate_border_bottom"></div>
			</div>
		</div>
	</div>
</div>
</section>

<section class="services-section">
	<div class="container">
		<div class="row">
			<div class="col-md-12 ">
				<ul class="connect_list">
				 <li>
					<a href="tel:9930000375">
						<div class="service-icon">
							<div class="icon">
								<!-- <i class='bx bx-phone-call'></i> -->
								<img src="assets/images/call-thin.png" alt="">
							</div>
							<div class="service-body">
								<div class="service-name">
									<h4> +91 99300 00375</h4>
								</div>
								<div class="service-para">
									<p>Call or leave a message on and we will return your call.</p>	
								</div>
	
							</div>
						</div>
					</a>
				
				 </li>
				 <li>
					<a href="mailTo:support@tplsport.com">
						<div class="service-icon">
							<div class="icon">
								<!-- <i class='bx bx-envelope' ></i> -->
								 <img src="assets/images/mail-thin.png" alt="">
							</div>
							<div class="service-body">
								<div class="service-name">
									<h4> support@tplsport.com</h4>
								</div>
								<div class="service-para">
									<p>Send us an email and we will respond within 2 business days.</p>	
								</div>
	
							</div>
						</div>
					</a>
					
				 </li>
				 <li>
					<a>
						<div class="service-icon">
							<div class="icon">
								<!-- <i class='bx bx-map' ></i> -->
								 <img src="assets/images/location-thin.png" alt="">
							</div>
							<div class="service-body">
								<div class="service-name">
									<h4>Address</h4>
								</div>
								<div class="service-para">
									<p>9th Floor, Office No.909, Lotus Surprising City, Link Road,
										Near Audi Showroom, Andheri West, Mumbai - 400053
										
									</p>	
								</div>
	
							</div>
						</div>
					</a>
				
				 </li>
				</ul>
			</div>
		</div>
	</div>
</section>